import "./IconWhatsApp.scss";

export const IconWhatsApp = () => {
  return <span className="icon-whats-app"></span>;
};
